import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isAgree:false,
    profitList:[],
    isTrue:false,
    currentPic:''
  },
  getters: {
  },
  mutations: {
    changeIsAgree(state,payload){
      state.isAgree = payload
    },
    changeProfitList(state,payload){
      state.profitList = payload
    },
    changeIsTrue(state,payload){
      state.isTrue = payload
    },
    changeCurrentPic(state,payload){
      state.currentPic = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
